import { FormControl, FormGroup } from "@angular/forms";
import { BaseObservableForm } from "apps-module/app/shared-library/forms/base-observable.form";
import { nameof } from "apps-module/app/shared-library/utils/common.utils";

import { DatesFilterOptions } from "../components/search-filters/dates-filter/dates-filter-options.enum";
import { SearchFilterModel } from "../models/search-filter.model";

export class SearchForm extends BaseObservableForm<SearchFilterModel> {
    public static createForm(initialSearchParams: SearchFilterModel): SearchForm {
        const formGroup = new FormGroup({
            searchContext: new FormControl<string>(initialSearchParams.searchContext),
            searchText: new FormControl<string>(initialSearchParams.searchText),
            pageNumber: new FormControl<number>(initialSearchParams.pageNumber),
            pageSize: new FormControl<number>(initialSearchParams.pageSize),
            sortOption: new FormControl<string>(initialSearchParams.sortOption),

            datesRange: new FormControl<DatesFilterOptions>(initialSearchParams.datesRange),
            fromDate: new FormControl<string>(initialSearchParams.fromDate),
            toDate: new FormControl<string>(initialSearchParams.toDate),

            trainingFormat: new FormControl<Array<string>>(initialSearchParams.trainingFormat),
            targetAudience: new FormControl<Array<string>>(initialSearchParams.targetAudience),
            coursePhase: new FormControl<Array<string>>(initialSearchParams.coursePhase),
            courseType: new FormControl<Array<string>>(initialSearchParams.courseType)
        });

        return new SearchForm(formGroup, initialSearchParams);
    }

    public get nativeForm(): FormGroup { return this.formInstance; }

    public get searchContext(): FormControl<string> { return this.formInstance.get(nameof<SearchFilterModel>("searchContext")) as FormControl<string>; }
    public get searchText(): FormControl<string> { return this.formInstance.get(nameof<SearchFilterModel>("searchText")) as FormControl<string>; }
    public get pageNumber(): FormControl<number> { return this.formInstance.get(nameof<SearchFilterModel>("pageNumber")) as FormControl<number>; }
    public get pageSize(): FormControl<number> { return this.formInstance.get(nameof<SearchFilterModel>("pageSize")) as FormControl<number>; }
    public get sortOption(): FormControl<string> { return this.formInstance.get(nameof<SearchFilterModel>("sortOption")) as FormControl<string>; }

    public get datesRange(): FormControl<DatesFilterOptions> { return this.formInstance.get(nameof<SearchFilterModel>("datesRange")) as FormControl<DatesFilterOptions>; }
    public get fromDate(): FormControl<string> { return this.formInstance.get(nameof<SearchFilterModel>("fromDate")) as FormControl<string>; }
    public get toDate(): FormControl<string> { return this.formInstance.get(nameof<SearchFilterModel>("toDate")) as FormControl<string>; }

    public get trainingFormat(): FormControl<Array<string>> { return this.formInstance.get(nameof<SearchFilterModel>("trainingFormat")) as FormControl<Array<string>>; }
    public get targetAudience(): FormControl<Array<string>> { return this.formInstance.get(nameof<SearchFilterModel>("targetAudience")) as FormControl<Array<string>>; }
    public get coursePhase(): FormControl<Array<string>> { return this.formInstance.get(nameof<SearchFilterModel>("coursePhase")) as FormControl<Array<string>>; }
    public get courseType(): FormControl<Array<string>> { return this.formInstance.get(nameof<SearchFilterModel>("courseType")) as FormControl<Array<string>>; }

    private constructor(
        formInstance: FormGroup,
        initialSearchParams: SearchFilterModel
    ) {
        super(formInstance, initialSearchParams);
    }

    public searchByText(): void {
        const sortOption = (this.searchText.value) ? "0" : this.sortOption.value;

        this.submit({
            pageNumber: 1,
            sortOption: sortOption,
            datesRange: this.initialFormState.datesRange,
            fromDate: this.initialFormState.fromDate,
            toDate: this.initialFormState.toDate
        });
    }

    public searchByDates(): void {
        this.submit({
            pageNumber: 1,
            searchText: this.initialFormState.searchText
        });
    }

    public searchByCategories(): void {
        this.submit({
            pageNumber: 1,
            searchText: this.initialFormState.searchText,
            datesRange: this.initialFormState.datesRange,
            fromDate: this.initialFormState.fromDate,
            toDate: this.initialFormState.toDate
        });
    }

    public changeSortOrder(): void {
        this.submit({
            pageNumber: 1,
            searchText: this.initialFormState.searchText,
            datesRange: this.initialFormState.datesRange,
            fromDate: this.initialFormState.fromDate,
            toDate: this.initialFormState.toDate
        });
    }

    public navigateToPageNumber(): void {
        this.submit({
            searchText: this.initialFormState.searchText,
            datesRange: this.initialFormState.datesRange,
            fromDate: this.initialFormState.fromDate,
            toDate: this.initialFormState.toDate
        });
    }

    public resetSearchFilters(): void {
        this.submit({
            pageNumber: 1,
            searchText: "",
            datesRange: DatesFilterOptions.All,
            fromDate: "",
            toDate: "",
            trainingFormat: [],
            targetAudience: [],
            coursePhase: [],
            courseType: []
        });

        window.location.reload();
    }
}
